import { render, staticRenderFns } from "./ReminderNotice.vue?vue&type=template&id=7f2d0f33&scoped=true&"
import script from "./ReminderNotice.vue?vue&type=script&lang=js&"
export * from "./ReminderNotice.vue?vue&type=script&lang=js&"
import style0 from "./ReminderNotice.vue?vue&type=style&index=0&id=7f2d0f33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d0f33",
  null
  
)

export default component.exports